const size = {
  mobile: '768px',
  desktop: '769px',
};

export const device = {
  mobile: `only screen and (max-width: ${size.mobile})`,
  desktop: `only screen and (min-width: ${size.desktop})`,
};
